//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OrderSettlement",
  data() {
    return {
      fileType: 4,
      settleRecord: [], // 订单结算记录
      settleSituation: {}, // 点单结算情况
      contractFileList: [], // 订单原件
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  created() {
    this.getSettleList();
    this.getWorkTypeSettleList();
  },
  methods: {
    /**
     * @descripttion: 获取订单结算记录
     * @Author: juanjuanhui
     * @Date: 2021-11-30 11:37:37
     * @param {*} param
     * @return {*}
     */
    getSettleList() {
      let params = { orderId: this.orderId };
      this.$http.order.getSettleList(params).then((res) => {
        this.settleRecord = res.data;
      });
    },
    /**
     * @descripttion: 获取订单结算情况
     * @Author: juanjuanhui
     * @Date: 2021-12-04 15:27:28
     * @param {*} param
     * @return {*}
     */
    getWorkTypeSettleList() {
      let params = { orderId: this.orderId };
      this.$http.order.getWorkTypeSettleList(params).then((res) => {
        this.settleSituation = res.data;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index < 6) return;
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.round((prev + curr) * 100) / 100;
            } else {
              return prev;
            }
          }, 0);
          //   sums[index] += " 元";
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    /**
     * @descripttion: 查看文件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:20:36
     * @param {*} id
     */
    handleLookFile(type, bizId) {
      let params = { type, bizId };
      this.getContractFileList(params);
    },
    /**
     * @descripttion: 获取合同附件
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getContractFileList(params) {
      this.$http.common.getContractFileList(params).then((res) => {
        let contractFileList = res.data,
          tempAry = [];
        contractFileList.forEach((item) => {
          tempAry.push(item.picPath);
        });
        this.contractFileList = tempAry;
        if (contractFileList.length > 0) {
          this.$refs.previewImg.showViewer = true;
        } else {
          this.$message({
            message: "暂无附件",
            type: "success",
          });
        }
      });
    },
  },
};
